import type { DeviceStatusIconSeverity } from '../components/devices/DeviceStatusIconZone';
import type { DeviceAlertSeverity } from '../types/device-alert';

export const ALERT_NO_LONGER_ACTIVE_HTTP_STATUSES = [404, 409] as const;

export const DEVICE_ALERT_SEVERITY_ORDER = [
  'critical',
  'warning',
  'info',
] as const satisfies readonly DeviceAlertSeverity[];

export const ALERT_SEVERITY_ICON_SLOT: Record<DeviceAlertSeverity, DeviceStatusIconSeverity> = {
  critical: 'monitoringError',
  warning: 'alertWarning',
  info: 'info',
};

export const DEVICE_ALERT_SEVERITY_TEXT_CLASS: Record<DeviceAlertSeverity, string> = {
  critical: 'text-destructive',
  warning: 'text-orange-dark',
  info: 'text-accent',
};

/** Every alert kind the card can describe, with the params its message cannot render without. */
export const ALERT_MESSAGE_REQUIRED_PARAMS: Record<string, readonly string[]> = {
  'pattern.pattern_detected': ['pattern', 'frequency'],
};

export const DEVICE_ALERT_TOOLTIP_DELAY_MS = 300;

export const REMEMBERED_DEVICE_ALERT_ID_LIMIT = 500;

// The wire type is a closed union, but zahrada may add a severity before this client knows it;
// ranking it as the least severe keeps it visible without outranking a known critical alert.
export const resolveAlertSeverity = (severity: string): DeviceAlertSeverity =>
  (DEVICE_ALERT_SEVERITY_ORDER as readonly string[]).includes(severity)
    ? (severity as DeviceAlertSeverity)
    : 'info';
